<div class="row" *ngIf="(offer | json) != '{}' || batchOffers.length>0">
    <!-- Carrier contact, drivers, truck, trailer -->
    <div class="col-sm-4">
        <h3 class="text-center">Carrier Info</h3>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Carrier Code
            </div>
            <div class="col-sm-9">
                <!--{{offer.carrierLane.carrier.carrierCode}}-->
                {{carrier.carrierCode}}
                <!--<select class="form-select"></select>-->
                <!--<select [(ngModel)]="orderStop.piecesUnitOfMeasureID">
        <option *ngFor="let unit of pieceUnits" value="{{unit.unitOfMeasureId}}">{{unit.code}}</option>
    </select>-->
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Carrier
            </div>
            <div class="col-sm-9">
                <!--{{offer.carrierLane.carrier.name}}-->
                {{carrier.name}}
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Contact
            </div>
            <div class="col-sm-7">
                <select name="contactID" [(ngModel)]="offer.quoteOrderLine.carrierContactId" class="form-select" (change)="contactChange($event)">
                    <option value=""></option>
                    <option *ngFor="let contact of contacts" value="{{contact.contactID}}">{{contact.contactName}}</option>
                </select>
            </div>
            <div class="col-sm-1">
                <button (click)="addContact('Dispatcher')" class="btn btn-sml btn-primary" title="Add Contact"><i class="fas fa-plus"></i></button>
            </div>
            <div class="col-sm-1">
                <button (click)="editContact('Dispatcher')" class="btn btn-sml btn-success" title="Edit Contact" *ngIf="offer.quoteOrderLine.carrierContactId>0"><i class="fas fa-pencil-alt"></i></button>
            </div>
        </div>
        <div class="row p-2" *ngIf="isAddDispatcher">
            <div class="col-sm-12 border border-primary bg-light m-2 p-2">
                <contact-quick-add [tableID]="searchOffer.carrierID" [contactTitleID]="2" [contactType]="'Carrier'" [countryCode]="countryCode" (onRefreshContact)="refreshContacts($event, 'Dispatcher')"></contact-quick-add>
            </div>
        </div>
        <div class="row p-2" *ngIf="isEditDispatcher">
            <div class="col-sm-12 border border-primary bg-light m-2 p-2">
                <contact-quick-edit [contactID]="offer.quoteOrderLine.carrierContactId" (onRefreshContact)="refreshContacts($event, 'Dispatcher')"></contact-quick-edit>
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Phone
            </div>
            <div class="col-sm-9">
                <div *ngIf="selectedContact.cell != '' && selectedContact.cell != null || selectedContact.phone != '' && selectedContact.phone != null">
                    <!--<kendo-maskedtextbox [mask]="phoneMask" class="form-control" type="text" [(ngModel)]="selectedContact.phone" [disabled]="true"></kendo-maskedtextbox>-->
                    <a href="tel:{{selectedContact.cell}}" *ngIf="selectedContact.cell != '' && selectedContact.cell != null">{{selectedContact.cellCountryAbbrev != null && selectedContact.cellCountryAbbrev != '' ? (selectedContact.cell | phone:selectedContact.cellCountryAbbrev.trim()) : (selectedContact.cell | phone:'US')}}</a>
                    <a href="tel:{{selectedContact.phone}}" *ngIf="selectedContact.cell == '' || selectedContact.cell == null">{{selectedContact.phoneCountryAbbrev != null && selectedContact.phoneCountryAbbrev != '' ? (selectedContact.phone | phone:selectedContact.phoneCountryAbbrev.trim()) : (selectedContact.phone | phone:'US')}}</a>
                </div>
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Email
            </div>
            <div class="col-sm-9">
                <input class="form-control" [ngClass]="(selectedContact.email==null||selectedContact.email=='') ? 'border border-danger' : ''" type="text" [(ngModel)]="selectedContact.email" [disabled]="true" [required]="true" />
                <!--<span *ngIf="selectedContact.email==null||selectedContact.email==''" class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>-->
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Driver 1 Name
            </div>
            <div class="col-sm-7">
                <select name="driverID" [(ngModel)]="offer.quoteOrderLine.driverId" class="form-select" (change)="driverChange($event, 1)">
                    <option value=""></option>
                    <option *ngFor="let driver of drivers" value="{{driver.contactID}}">{{driver.contactName}}</option>
                </select>
            </div>
            <div class="col-sm-1">
                <button (click)="addContact('Driver1')" class="btn btn-sml btn-primary" title="Add Driver"><i class="fas fa-plus"></i></button>
            </div>
            <div class="col-sm-1">
                <button (click)="editContact('Driver1')" class="btn btn-sml btn-success" title="Edit Driver" *ngIf="offer.quoteOrderLine.driverId>0"><i class="fas fa-pencil-alt"></i></button>
            </div>
        </div>
        <div class="row p-2" *ngIf="isAddDriver1">
            <div class="col-sm-12 border border-primary bg-light m-2 p-2">
                <contact-quick-add [tableID]="searchOffer.carrierID" [contactTitleID]="3" [contactType]="'Carrier'" [countryCode]="countryCode" (onRefreshContact)="refreshContacts($event, 'Driver1')"></contact-quick-add>
            </div>
        </div>
        <div class="row p-2" *ngIf="isEditDriver1">
            <div class="col-sm-12 border border-primary bg-light m-2 p-2">
                <contact-quick-edit [contactID]="offer.quoteOrderLine.driverId" (onRefreshContact)="refreshContacts($event, 'Driver1')"></contact-quick-edit>
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Driver 1 Cell
            </div>
            <div class="col-sm-9">
                <!--<kendo-maskedtextbox [mask]="phoneMask" class="form-control" type="text" [(ngModel)]="selectedDriver.cell"
                         [ngClass]="(macropointLocationProviderDevice=='Mobile'&&(selectedDriver.cell==''||selectedDriver.cell==null)) ? 'border border-danger' : ''"
                         [disabled]="true" [required]="macropointLocationProviderDevice=='Mobile'"></kendo-maskedtextbox>-->
                <!--<a href="tel:{{selectedDriver.cell}}">{{selectedDriver.cellCountryID > 0 ? (selectedDriver.cell | phone:selectedDriver.cellCountry.abbrev.trim()) : (selectedDriver.cell | phone:'US')}}</a>-->
                <a href="tel:{{selectedDriver.cell}}">{{selectedDriver.cellCountryAbbrev != null && selectedDriver.cellCountryAbbrev != '' ? (selectedDriver.cell | phone:selectedDriver.cellCountryAbbrev.trim()) : (selectedDriver.cell | phone:'US')}}</a>
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Driver 2 Name
            </div>
            <div class="col-sm-7">
                <select name="driver2ID" [(ngModel)]="offer.quoteOrderLine.driver2Id" class="form-select" (change)="driverChange($event, 2)">
                    <option value=""></option>
                    <option *ngFor="let driver of drivers" value="{{driver.contactID}}">{{driver.contactName}}</option>
                </select>
            </div>
            <div class="col-sm-1">
                <button (click)="addContact('Driver2')" class="btn btn-sml btn-primary" title="Add Driver"><i class="fas fa-plus"></i></button>
            </div>
            <div class="col-sm-1">
                <button (click)="editContact('Driver2')" class="btn btn-sml btn-success" title="Edit Driver" *ngIf="offer.quoteOrderLine.driver2Id>0"><i class="fas fa-pencil-alt"></i></button>
            </div>
        </div>
        <div class="row p-2" *ngIf="isAddDriver2">
            <div class="col-sm-12 border border-primary bg-light m-2 p-2">
                <contact-quick-add [tableID]="searchOffer.carrierID" [contactTitleID]="3" [contactType]="'Carrier'" [countryCode]="countryCode" (onRefreshContact)="refreshContacts($event, 'Driver2')"></contact-quick-add>
            </div>
        </div>
        <div class="row p-2" *ngIf="isEditDriver2">
            <div class="col-sm-12 border border-primary bg-light m-2 p-2">
                <contact-quick-edit [contactID]="offer.quoteOrderLine.driver2Id" (onRefreshContact)="refreshContacts($event, 'Driver2')"></contact-quick-edit>
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Driver 2 Cell
            </div>
            <div class="col-sm-9">
                <!--<kendo-maskedtextbox [mask]="phoneMask" class="form-control" type="text" [(ngModel)]="selectedDriver2.cell" [disabled]="true"></kendo-maskedtextbox>-->
                <!--<a href="tel:{{selectedDriver2.cell}}">{{selectedDriver2.cellCountryID > 0 ? (selectedDriver2.cell | phone:selectedDriver2.cellCountry.abbrev.trim()) : (selectedDriver2.cell | phone:'US')}}</a>-->
                <a href="tel:{{selectedDriver2.cell}}">{{selectedDriver2.cellCountryAbbrev != null && selectedDriver2.cellCountryAbbrev != '' ? (selectedDriver2.cell | phone:selectedDriver2.cellCountryAbbrev.trim()) : (selectedDriver2.cell | phone:'US')}}</a>
            </div>
        </div>
        <div class="row p-2" *ngIf="macropointLocationProviderDevice!='VehicleID'">
            <div class="col-sm-3 fw-bold text-end">
                Truck #
            </div>
            <div class="col-sm-9">
                <input class="form-control" type="text" [(ngModel)]="offer.quoteOrderLine.truckNumber"
                       [ngClass]="(macropointLocationProviderDevice=='VehicleID'&&(offer.quoteOrderLine.truckNumber==''||offer.quoteOrderLine.truckNumber==null)) ? 'border border-danger' : ''"
                       [required]="macropointLocationProviderDevice=='VehicleID'" (change)="validate(false)"
                       [disabled]="macropointLocationProviderDevice=='VehicleID'" />
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Trailer #
            </div>
            <div class="col-sm-9">
                <input class="form-control" type="text" [(ngModel)]="offer.quoteOrderLine.trailerNumber"
                       [ngClass]="(macropointLocationProviderDevice=='TrailerID'&&(offer.quoteOrderLine.trailerNumber==''||offer.quoteOrderLine.trailerNumber==null)) ? 'border border-danger' : ''"
                       [required]="macropointLocationProviderDevice=='TrailerID'" (change)="validate(false)" />
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                External Tracking Link
            </div>
            <div class="col-sm-9">
                <input type="text" [(ngModel)]="offer.quoteOrderLine.externalTrackingLink" class="form-control" placeholder="eg. https://www.google.com" (keyup)="isValidUrl(offer.quoteOrderLine.externalTrackingLink)" />
            </div>
        </div>
        <div class="row p-1">
            <div class="col-sm-3 fw-bold text-end">Load Req'd Services</div>
            <div class="col">
                <div class="row" *ngFor="let item of searchLoadCarrierServiceList">
                    <div class="col-sm-4">
                        <input type="checkbox" style="margin:10px;transform: scale(1.5);" [checked]="isCarrierServiceMap(item.carrierServiceID) || item.overrideManagerEmployeeID > 0" disabled />
                        <label class="fw-bold" [ngClass]="(isCarrierServiceMap(item.carrierServiceID) || item.overrideManagerEmployeeID > 0) ? '' : 'text-danger'">{{item.carrierServiceDescription}}</label>
                    </div>
                    <div class="col-sm-3" *ngIf="!isCarrierServiceMap(item.carrierServiceID) && item.overrideManagerEmployeeID == null">
                        <button class="btn btn-sm m-1 btn-primary" (click)="overrideLoadServiceMap(item.quoteOrderLineCarrierServiceMapID)">Override</button>
                    </div>
                    <div class="col-sm-3" *ngIf="!isCarrierServiceMap(item.carrierServiceID) && item.overrideManagerEmployeeID > 0">
                        <button class="btn btn-sm m-1 btn-primary" (click)="overrideLoadServiceMap(item.quoteOrderLineCarrierServiceMapID)">Edit</button>
                    </div>
                    <div class="col" *ngIf="!isCarrierServiceMap(item.carrierServiceID) && item.overrideManagerEmployeeID > 0 && !isServiceOverride">
                        {{item.overrideManagerEmployeeName}}<br />
                        {{item.overrideNote}}<br />
                    </div>
                </div>
            </div>
            <div class="col" *ngIf="isServiceOverride">
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Service Override Mgr</label><br />
                        <select name="overrideManagerEmployeeID" [(ngModel)]="loadServiceMap.overrideManagerEmployeeID">
                            <option *ngFor="let item of accountManagers" value="{{item.employeeId}}">{{item.fullName}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Service Override Note</label><br />
                        <textarea style="width:80%" class="form-control" rows="5" [(ngModel)]="loadServiceMap.overrideNote"></textarea>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <button class="btn btn-sm m-1 btn-primary" (click)="saveLoadServiceMap()">Save</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row p-2">
            <div class="col">
                <ul class="alert alert-danger p-1" *ngIf="isPPCChanged">
                    <li>PPC Changed. Schedule will be deleted and recreated.</li>
                </ul>
                <!--<button class="btn btn-primary m-2" (click)="sendEmail()">Send Email [TESTING]</button>-->
                <ul class="alert alert-danger p-1" *ngIf="validationWarningList.length > 0">
                    <li *ngFor="let warning of validationWarningList">{{warning}}</li>
                </ul>
            </div>
        </div>
    </div>
    <!-- Costs, CSR, PPC, Acct Mgr -->
    <div class="col-sm-4">
        <h3 class="text-center">Settlement Info</h3>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Unit
            </div>
            <div class="col-sm-9">
                <input class="form-control" type="text" [(ngModel)]="payDetail.unit" [disabled]="true" />
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Quantity
            </div>
            <div class="col-sm-9">
                <input class="form-control" type="text" [(ngModel)]="payDetail.quantity" [disabled]="true" />
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Linehaul Cost
            </div>
            <div class="col-sm-9">
                <input class="form-control" type="number" [(ngModel)]="offer.quoteOrderLine.cost" step="0.01" (chnage)="validate(false)" [disabled]="viewType=='Unverified'" />
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Fuel Cost
            </div>
            <div class="col-sm-9">
                <input class="form-control" type="number" [(ngModel)]="offer.quoteOrderLine.fuelCost" step="0.01" (chnage)="validate(false)" [disabled]="viewType=='Unverified'" />
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Acc. Cost
            </div>
            <div class="col-sm-9">
                <input class="form-control" type="number" [(ngModel)]="offer.quoteOrderLine.accessorialCost" step="0.01" (chnage)="validate(false)" [disabled]="viewType=='Unverified'" />
            </div>
        </div>
        <div class="row p-2" *ngIf="offer.quoteOrderLine.accessorialCost>0">
            <div class="col-sm-3 fw-bold text-end">
                Acc. Cost Notes
            </div>
            <div class="col-sm-9">
                <input class="form-control" type="text" [(ngModel)]="accessorialCostNotes" [disabled]="viewType=='Unverified'" />
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Total
            </div>
            <div class="col-sm-9">
                <input class="form-control" type="number" [value]="getTotalCost()" [disabled]="true" [ngClass]="viewType!='orderentry'&&getTotalCost()<1 ? 'border border-danger' : ''" />
            </div>
        </div>
        <div class="row p-2" *ngIf="offer.quoteOrderLine.maxCarrierPay!=null&&getTotalCost()>offer.quoteOrderLine.maxCarrierPay">
            <div class="col-sm-3 fw-bold text-end text-danger">
                Manager
            </div>
            <div class="col-sm-9">
                <select name="csManagerEmployeeID" [(ngModel)]="offer.csManagerEmployeeID"
                        [ngClass]="getTotalCost()>offer.quoteOrderLine.maxCarrierPay&&(offer.csManagerEmployeeID==0||offer.csManagerEmployeeID==null) ? 'border border-danger' : ''"
                        class="form-select" (change)="csManagerEmployeeChange($event)" [disabled]="viewType=='Unverified'" required>
                    <option *ngFor="let mgr of carrierSalesManagers" value="{{mgr.employeeId}}">{{mgr.fullName}}</option>
                </select>
            </div>
        </div>
        <div class="row p-2" *ngIf="offer.quoteOrderLine.maxCarrierPay!=null&&getTotalCost()>offer.quoteOrderLine.maxCarrierPay">
            <div class="col-sm-3 fw-bold text-end text-danger">
                Over Max Pay Notes
            </div>
            <div class="col-sm-9">
                <input class="form-control" type="text" [(ngModel)]="offer.overMaxPayNotes" (change)="overMaxPayNotesChange($event)"
                       [ngClass]="getTotalCost()>offer.quoteOrderLine.maxCarrierPay&&(offer.csManagerEmployeeID==0||offer.csManagerEmployeeID==null) ? 'border border-danger' : ''"
                       [disabled]="viewType=='Unverified'" />
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Carrier Rep
            </div>
            <div class="col-sm-9">
                <select name="awardedCarrierRepId" [(ngModel)]="offer.quoteOrderLine.awardedCarrierRepId" class="form-select"
                        (change)="carrierRepChange($event)"
                        [disabled]="offer.awarded==true&&!isCSRManager||viewType=='Unverified'">
                    <option *ngFor="let rep of carrierReps" value="{{rep.employeeId}}">{{rep.fullName}}</option>
                </select>
            </div>
        </div>
        <div class="row p-2" *ngIf="false&&viewType=='orderentry'">
            <div class="col-sm-3">
            </div>
            <div class="col-sm-9 text-primary fw-bold">
                <input type="checkbox" [(ngModel)]="isAutoComplete" style="transform:scale(1.5);margin-right:5px;" />
                Auto complete stops & skip tracking
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                PPC City, ST
            </div>
            <div class="col-sm-9">
                <div class="row">
                    <div class="col-sm-8">
                        <!--<city-dropdown [parentForm]="offerForm" [ctrlName]="'ppcCityControl'" [placeholder]="'Select a City'"
                    [isCityStateZip]="true" (citySelected)="ppcCitySet($event,false)"
                    [isDisabled]="loadStatus=='Dispatched'||loadStatus=='Started'" [isRequired]="true"></city-dropdown>-->
                        <city-state-zip-dropdown [parentForm]="offerForm" [ctrlName]="'ppcCityStateZipCtrl'" [placeholder]="'Select a City'"
                                                 (citySelected)="ppcCitySTChanged($event, false)" [defaultCity]="defaultPPCCity"
                                                 [cityID]="ppcCity.cityID" [isChooseDefaultZip]="true"
                                                 [isDisabled]="loadStatus=='Dispatched'||loadStatus=='Started'" [isRequired]="true"></city-state-zip-dropdown>
                    </div>
                    <div class="col-sm-4 fw-bold text-primary h5">
                        {{ppcMilesText}}
                    </div>
                </div>
                <div class="row" *ngIf="ppcTravelText!=''">
                    <div class="col-sm-12 fw-bold text-danger">
                        Carrier will be late based on first pickup latest time.<br />
                        {{ppcTravelText}}
                    </div>
                </div>
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                PPC Notes
            </div>
            <div class="col-sm-9">
                <input class="form-control" type="text" [(ngModel)]="ppcNotes" (change)="isPPCChanged=true" />
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Date/Time
            </div>
            <div class="col-sm-9">
                <div class="row">
                    <div class="col-sm-5">
                        <kendo-datepicker name="ppcDate" [(ngModel)]="ppcDate" [format]="'MM/dd/yyyy'"
                                          [ngModelOptions]="{standalone: true}" (valueChange)="ppcDateChanged()"
                                          [disabled]="(ppcCity | json) == '{}' || loadStatus == 'Dispatched' || loadStatus == 'Started' || batchOffers.length > 0 && isBatchPPCTimeSame != true"
                                          required>
                        </kendo-datepicker>
                        <!--<span *ngIf="!isStopValid" class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>-->
                    </div>
                    <div class="col-sm-4">
                        <kendo-timepicker name="ppcTime" [(ngModel)]="ppcDate" [format]="'HH:mm'"
                                          [ngModelOptions]="{standalone: true}" (valueChange)="ppcDateChanged()"
                                          [disabled]="(ppcCity | json) == '{}' || loadStatus == 'Dispatched' || loadStatus == 'Started' || batchOffers.length > 0 && isBatchPPCTimeSame != true"
                                          required>
                        </kendo-timepicker>
                        <!--<span *ngIf="!isStopValid" class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>-->
                    </div>
                </div>
                <div class="row">
                    <div class="col" *ngIf="(ppcCity | json) == '{}'">
                        <span class="text-danger">Please select PPC City for using time zone in PPC Date/Time</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row p-2" *ngIf="batchOffers.length>0&&isBatchPPCTimeSame!=true">
            <div class="col-sm-3 fw-bold text-end">
                Hours Before
            </div>
            <div class="col-sm-5">
                <input type="number" [(ngModel)]="ppcHoursBefore" />
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                First Pickup<br />Earliest
            </div>
            <div class="col-sm-5">
                <kendo-datepicker name="firstPickupEarliestDate" [(ngModel)]="firstPickupEarliestDate" [format]="'MM/dd/yyyy'" [ngModelOptions]="{standalone: true}" [disabled]="true">
                </kendo-datepicker>
            </div>
            <div class="col-sm-4">
                <kendo-timepicker name="firstPickupEarliestTime" [(ngModel)]="firstPickupEarliestDate" [format]="'HH:mm'" [ngModelOptions]="{standalone: true}" [disabled]="true">
                </kendo-timepicker>
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Latest
            </div>
            <div class="col-sm-5">
                <kendo-datepicker name="firstPickupLatestDate" [(ngModel)]="firstPickupLatestDate" [format]="'MM/dd/yyyy'" [ngModelOptions]="{standalone: true}" [disabled]="true">
                </kendo-datepicker>
            </div>
            <div class="col-sm-4">
                <kendo-timepicker name="firstPickupLatestTime" [(ngModel)]="firstPickupLatestDate" [format]="'HH:mm'" [ngModelOptions]="{standalone: true}" [disabled]="true">
                </kendo-timepicker>
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Account Mgr
            </div>
            <div class="col-sm-9">
                {{searchQuoteOrderLine.accountManagerName}}
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Confirmed Pickup w/ Carrier
            </div>
            <div class="col-sm-9">
                <input type="checkbox" [(ngModel)]="offer.quoteOrderLine.loadVerified" style="transform:scale(1.5);"
                       [disabled]="ppcCity==null||(ppcCity|json)=='{}'||offer.quoteOrderLine.driverId==null||offer.quoteOrderLine.driverId<=0" />
            </div>
        </div>
    </div>
    <!-- Macropoint and Save checklist -->
    <div class="col-sm-4">
        <h3 class="text-center">Macropoint</h3>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Track Via
            </div>
            <div class="col-sm-9">
                <select name="macropointLocationProviderId" [(ngModel)]="macropointLocationProviderId" class="form-select" (change)="macropointLocationProviderChange($event)">
                    <option *ngFor="let provider of macropointLocationProviders" value="{{provider.macropointLocationProviderId}}">{{provider.device}}</option>
                </select>
            </div>
        </div>
        <div class="row p-2" *ngIf="macropointLocationProviderDevice == 'VehicleID'">
            <div class="col-sm-3 fw-bold text-end">
                Truck #
            </div>
            <div class="col-sm-9">
                <select name="macropointGoodTruckID" [(ngModel)]="goodTruckEquipmentID" class="form-select" (change)="macropointGoodTruckChange($event)">
                    <option value="- Other -">- Other -</option>
                    <option *ngFor="let truck of macropointGoodTruckList" value="{{truck.equipmentID}}">{{truck.equipmentID}}</option>
                </select>
                <br />
                <span *ngIf="goodTruckEquipmentID == '- Other -'">Other: <input type="text" [(ngModel)]="offer.quoteOrderLine.truckNumber" /></span>
            </div>
        </div>
        <div class="row p-2" *ngIf="macropointLocationProviderDevice == 'VehicleID'">
            <div class="col-sm-4 fw-bold text-end">
                Truck not found?
            </div>
            <div class="col-sm-8">
                <button type="button" class="btn btn-secondary" (click)="getMacropointGoodTrucks(true)">Update Trucks</button>
                <br />
                Select "Other" if still not found and type the missing truck #.
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Begin Tracking
            </div>
            <div class="col-sm-5">
                <kendo-datepicker name="beginTrackingDate" [(ngModel)]="beginTrackingDate" [format]="'MM/dd/yyyy'" [ngModelOptions]="{standalone: true}" [disabled]="true">
                </kendo-datepicker>
            </div>
            <div class="col-sm-4">
                <kendo-timepicker name="beginTrackingTime" [(ngModel)]="beginTrackingDate" [format]="'HH:mm'" [ngModelOptions]="{standalone: true}" [disabled]="true">
                </kendo-timepicker>
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                End Tracking
            </div>
            <div class="col-sm-5">
                <kendo-datepicker name="endTrackingDate" [(ngModel)]="endTrackingDate" [format]="'MM/dd/yyyy'" [ngModelOptions]="{standalone: true}" [disabled]="true">
                </kendo-datepicker>
            </div>
            <div class="col-sm-4">
                <kendo-timepicker name="endTrackingTime" [(ngModel)]="endTrackingDate" [format]="'HH:mm'" [ngModelOptions]="{standalone: true}" [disabled]="true">
                </kendo-timepicker>
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Location Updates
            </div>
            <div class="col-sm-9">
                <select name="trackingID" [(ngModel)]="macropointTrackInterval" class="form-select">
                    <option value=""></option>
                    <option *ngFor="let option of macropointTrackingOptions" value="{{option.macropointTrackingOptionID}}">{{option.locationProvider}}: {{option.locationUpdatesEvery}}</option>
                </select>
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Event Updates
            </div>
            <div class="col-sm-9">
                <input type="checkbox" [(ngModel)]="macropointEventUpdates" style="transform:scale(1.5);" />
            </div>
        </div>
        <div class="row p-2">
            <div class="col-sm-3 fw-bold text-end">
                Emails
            </div>
            <div class="col-sm-9">
                <input class="form-control" type="text" [(ngModel)]="macropointEmails" />
            </div>
        </div>
        <!-- Saving status steps -->
        <div class="row p-2" *ngIf="isSaving">
            <div class="col-sm-1 text-end">
                <mat-spinner [diameter]="14" *ngIf="saveStatusOffer==1"></mat-spinner>
                <i class="far fa-times-circle text-danger" *ngIf="saveStatusOffer==2"></i>
                <i class="fas fa-check text-success" *ngIf="saveStatusOffer==3"></i>
            </div>
            <div class="col-sm-11">
                Saving offer and order info
            </div>
        </div>
        <div class="row p-2" *ngIf="isSaving && loadStatus != 'Dispatched' && loadStatus != 'Started' && (viewType != 'Booked' && viewType != 'Unverified' || isPPCChanged)">
            <div class="col-sm-1 text-end">
                <mat-spinner [diameter]="14" *ngIf="saveStatusDeleteSched==1"></mat-spinner>
                <i class="far fa-times-circle text-danger" *ngIf="saveStatusDeleteSched==2"></i>
                <i class="fas fa-check text-success" *ngIf="saveStatusDeleteSched==3"></i>
            </div>
            <div class="col-sm-11">
                Deleting current schedule
            </div>
        </div>
        <div class="row p-2" *ngIf="isSaving&&loadStatus != 'Dispatched' && loadStatus != 'Started' && (viewType != 'Booked' && viewType != 'Unverified' || isPPCChanged)">
            <div class="col-sm-1 text-end">
                <mat-spinner [diameter]="14" *ngIf="saveStatusSetSched==1"></mat-spinner>
                <i class="far fa-times-circle text-danger" *ngIf="saveStatusSetSched==2"></i>
                <i class="fas fa-check text-success" *ngIf="saveStatusSetSched==3"></i>
            </div>
            <div class="col-sm-11">
                Setting schedule
            </div>
        </div>
        <div class="row p-2" *ngIf="isSaving && (viewType != 'Booked' && viewType != 'Unverified' || isPPCChanged)">
            <div class="col-sm-1 text-end">
                <mat-spinner [diameter]="14" *ngIf="saveStatusPPC==1"></mat-spinner>
                <i class="far fa-times-circle text-danger" *ngIf="saveStatusPPC==2"></i>
                <i class="fas fa-check text-success" *ngIf="saveStatusPPC==3"></i>
            </div>
            <div class="col-sm-11">
                Saving pre-pickup
            </div>
        </div>
        <div class="row p-2" *ngIf="isSaving && (viewType != 'Booked' && viewType != 'Unverified' || isPPCChanged)">
            <div class="col-sm-1 text-end">
                <mat-spinner [diameter]="14" *ngIf="saveStatusSched==1"></mat-spinner>
                <i class="far fa-times-circle text-danger" *ngIf="saveStatusSched==2"></i>
                <i class="fas fa-check text-success" *ngIf="saveStatusSched==3"></i>
            </div>
            <div class="col-sm-11">
                Saving tracking schedule
            </div>
        </div>
        <div class="row p-2" *ngIf="isSaving">
            <div class="col-sm-1 text-end">
                <mat-spinner [diameter]="14" *ngIf="saveStatusAwardCarrier==1"></mat-spinner>
                <i class="far fa-times-circle text-danger" *ngIf="saveStatusAwardCarrier==2"></i>
                <i class="fas fa-check text-success" *ngIf="saveStatusAwardCarrier==3"></i>
            </div>
            <div class="col-sm-11" *ngIf="viewType!='Unverified'">
                Awarding carrier
            </div>
            <div class="col-sm-11" *ngIf="viewType=='Unverified'">
                Updating awarded carrier
            </div>
        </div>
        <div class="row p-2" *ngIf="!isExportHub && isSaving && (viewType != 'Booked' && viewType != 'Unverified' || isPPCChanged) && searchQuoteOrderLine.externalOrderNumber != null && searchQuoteOrderLine.externalOrderNumber != ''">
            <div class="col-sm-1 text-end">
                <mat-spinner [diameter]="14" *ngIf="saveStatusTMW==1"></mat-spinner>
                <i class="far fa-times-circle text-danger" *ngIf="saveStatusTMW==2"></i>
                <i class="fas fa-check text-success" *ngIf="saveStatusTMW==3"></i>
            </div>
            <div class="col-sm-11">
                Updating TMW order
            </div>
        </div>
        <div class="row p-2" *ngIf="isSaving && (viewType != 'Unverified' || isPPCChanged)">
            <div class="col-sm-1 text-end">
                <mat-spinner [diameter]="14" *ngIf="saveStatusPayDetail==1"></mat-spinner>
                <i class="far fa-times-circle text-danger" *ngIf="saveStatusPayDetail==2"></i>
                <i class="fas fa-check text-success" *ngIf="saveStatusPayDetail==3"></i>
            </div>
            <div class="col-sm-11">
                Saving pay details
            </div>
        </div>
        <div class="row p-2" *ngIf="!isExportHub && isSaving && (viewType != 'Booked' && viewType != 'Unverified' || isPPCChanged) && searchQuoteOrderLine.externalOrderNumber != null && searchQuoteOrderLine.externalOrderNumber != ''">
            <div class="col-sm-1 text-end">
                <mat-spinner [diameter]="14" *ngIf="saveStatusTMWMove==1"></mat-spinner>
                <i class="far fa-times-circle text-danger" *ngIf="saveStatusTMWMove==2"></i>
                <i class="fas fa-check text-success" *ngIf="saveStatusTMWMove==3"></i>
            </div>
            <div class="col-sm-11">
                Updating TMW move/sequence
            </div>
        </div>
        <div class="row p-2" *ngIf="isSaving">
            <div class="col-sm-1 text-end">
                <mat-spinner [diameter]="14" *ngIf="saveStatusMacropoint==1"></mat-spinner>
                <i class="far fa-times-circle text-danger" *ngIf="saveStatusMacropoint==2"></i>
                <i class="fas fa-check text-success" *ngIf="saveStatusMacropoint==3"></i>
            </div>
            <div class="col-sm-11">
                Updating Macropoint
            </div>
        </div>
        <div class="row p-2" *ngIf="isSaving && viewType == 'orderentry' && isAutoComplete">
            <div class="col-sm-1 text-end">
                <mat-spinner [diameter]="14" *ngIf="saveStatusAutoComplete==1"></mat-spinner>
                <i class="far fa-times-circle text-danger" *ngIf="saveStatusAutoComplete==2"></i>
                <i class="fas fa-check text-success" *ngIf="saveStatusAutoComplete==3"></i>
            </div>
            <div class="col-sm-11">
                Auto-completing order
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-sm-6">
        <kendo-expansionpanel [title]="'Pay Detail'"
                              [subtitle]=""
                              [expanded]="isPayDetailExpanded"
                              (action)="togglePayDetail()">
            <pay-detail-grid [quoteOrderLineID]="offer.quoteOrderLineID"
                             [orderNumber]="searchQuoteOrderLine.orderNumber"
                             [viewType]="'quoteorderline'"
                             [pageType]="'procurement'"
                             [refreshDate]="payDetailRefreshDate">
            </pay-detail-grid>
        </kendo-expansionpanel>
    </div>
    <!-- Main Buttons -->
    <div class="col-sm-3 text-end" *ngIf="viewType != 'Booked' && viewType != 'Unverified'">
        <button type="button" class="btn btn-primary m-2" (click)="saveOffer(false, false)" [disabled]="isSaving==true || validationWarningList.length > 0">Save</button>
        <button type="button" class="btn btn-primary m-2" (click)="saveOffer(false, true)" [disabled]="isSaving==true || validationWarningList.length > 0">Save and Email</button>
        <button type="button" class="btn btn-secondary m-2" (click)="cancelOffer()" *ngIf="this.offer.awarded != true">Cancel Procurement</button>
        <button type="button" class="btn btn-secondary m-2" (click)="cancelEdit()" *ngIf="this.offer.awarded == true">Cancel Edit</button>
    </div>
    <div class="col-sm-3 text-end" *ngIf="viewType == 'Booked'">
        <button type="button" class="btn btn-primary m-2" (click)="saveBookedOffer(false, false)" [disabled]="isSaving==true || validationWarningList.length > 0" *ngIf="!isPPCChanged">Save</button>
        <button type="button" class="btn btn-primary m-2" (click)="saveOffer(false, false)" [disabled]="isSaving==true || validationWarningList.length > 0" *ngIf="isPPCChanged">Save</button>
        <button type="button" class="btn btn-primary m-2" (click)="saveBookedOffer(false, true)" [disabled]="isSaving==true || validationWarningList.length > 0" *ngIf="!isPPCChanged">Save and Email</button>
        <button type="button" class="btn btn-primary m-2" (click)="saveOffer(false, true)" [disabled]="isSaving==true || validationWarningList.length > 0" *ngIf="isPPCChanged">Save and Email</button>
        <button type="button" class="btn btn-secondary m-2" (click)="cancelOffer()" *ngIf="this.offer.awarded != true">Cancel Procurement</button>
        <button type="button" class="btn btn-secondary m-2" (click)="cancelEdit()" *ngIf="this.offer.awarded == true">Cancel Edit</button>
    </div>
    <div class="col-sm-3 text-end" *ngIf="viewType == 'Unverified'">
        <button type="button" class="btn btn-primary m-2" (click)="saveUnverifiedOffer(false, false)" [disabled]="isSaving==true || validationWarningList.length > 0" *ngIf="!isPPCChanged">Save</button>
        <button type="button" class="btn btn-primary m-2" (click)="saveOffer(false, false)" [disabled]="isSaving==true || validationWarningList.length > 0" *ngIf="isPPCChanged">Save</button>
        <button type="button" class="btn btn-primary m-2" (click)="saveUnverifiedOffer(false, true)" [disabled]="isSaving==true || validationWarningList.length > 0" *ngIf="!isPPCChanged">Save and Email</button>
        <button type="button" class="btn btn-primary m-2" (click)="saveOffer(false, true)" [disabled]="isSaving==true || validationWarningList.length > 0" *ngIf="isPPCChanged">Save and Email</button>
        <button type="button" class="btn btn-secondary m-2" (click)="cancelOffer()" *ngIf="this.offer.awarded != true">Cancel Procurement</button>
        <button type="button" class="btn btn-secondary m-2" (click)="cancelEdit()" *ngIf="this.offer.awarded == true">Cancel Edit</button>
    </div>

    <!-- Macropoint Buttons -->
    <div class="col-sm-3 text-end" *ngIf="viewType != 'Booked' && viewType != 'Unverified'">
        <button type="button" class="btn btn-primary m-2" (click)="saveOffer(true, false)" [disabled]="isSaving==true || validationWarningList.length > 0">Save Macropoint</button>
        <button type="button" class="btn btn-primary m-2" (click)="saveOffer(true, true)" [disabled]="isSaving==true || validationWarningList.length > 0">Save Macropoint and Email</button>
    </div>
    <div class="col-sm-3 text-end" *ngIf="viewType == 'Booked'">
        <button type="button" class="btn btn-primary m-2" (click)="saveBookedOffer(true, false)" [disabled]="isSaving==true || validationWarningList.length > 0" *ngIf="!isPPCChanged">Save Macropoint</button>
        <button type="button" class="btn btn-primary m-2" (click)="saveOffer(true, false)" [disabled]="isSaving==true || validationWarningList.length > 0" *ngIf="isPPCChanged">Save Macropoint</button>
        <button type="button" class="btn btn-primary m-2" (click)="saveBookedOffer(true, true)" [disabled]="isSaving==true || validationWarningList.length > 0" *ngIf="!isPPCChanged">Save Macropoint and Email</button>
        <button type="button" class="btn btn-primary m-2" (click)="saveOffer(true, true)" [disabled]="isSaving==true || validationWarningList.length > 0" *ngIf="isPPCChanged">Save Macropoint and Email</button>
    </div>
    <div class="col-sm-3 text-end" *ngIf="viewType == 'Unverified'">
        <button type="button" class="btn btn-primary m-2" (click)="saveUnverifiedOffer(true, false)" [disabled]="isSaving==true || validationWarningList.length > 0" *ngIf="!isPPCChanged">Save Macropoint</button>
        <button type="button" class="btn btn-primary m-2" (click)="saveOffer(true, false)" [disabled]="isSaving==true || validationWarningList.length > 0" *ngIf="isPPCChanged">Save Macropoint</button>
        <button type="button" class="btn btn-primary m-2" (click)="saveUnverifiedOffer(true, true)" [disabled]="isSaving==true || validationWarningList.length > 0" *ngIf="!isPPCChanged">Save Macropoint and Email</button>
        <button type="button" class="btn btn-primary m-2" (click)="saveOffer(true, true)" [disabled]="isSaving==true || validationWarningList.length > 0" *ngIf="isPPCChanged">Save Macropoint and Email</button>
    </div>
</div>
